module.exports = __webpack_public_path__ + "a43735af929e80fab4714d9fc9cbe837.svg";